<template>
    <div id="login-change" class="basket-user">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle basket-user__icon btn" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg class="icon icon-user d-sm-none" fill="currentColor">
                    <use xlink:href="#user" />
                </svg>
                <span class="d-none d-lg-block">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <h6 class="dropdown-header">Benutzerkonto</h6>
                <a class="dropdown-item" :href="$ceres.urls.myAccount">
                {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                <a class="dropdown-item" href="#" v-logout> {{ $translate("Ceres::Template.loginLogout") }}</a>
            </div>
        </div>
        <div v-if="!isLoggedIn" class="dropdown">
            <a href="#" class="dropdown-toggle basket-user__icon btn" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg class="icon icon-user" fill="currentColor">
                    <use xlink:href="#user" />
                </svg>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <h6 class="dropdown-header">Benutzerkonto</h6>
                <a class="dropdown-item"
                   :href="isLogin ? 'javascript:void(0)' : '#login'"
                   :data-toggle="isLogin ? false : 'modal'"
                   @click="createLoginModal();unmarkInputFields()"
                   :aria-label="$translate('Ceres::Template.login')"
                   data-testing="login-select">
                    <span class="hidden-xs-down">{{ $translate("Ceres::Template.login") }}</span>
                </a>
                <a class="dropdown-item" :href="$ceres.urls.registration + '?b2c'">
                    <span class="hidden-xs-down">{{ $translate("ODKleinMore::Template.loginRegisterB2C") }}</span>
                </a>
                <a class="dropdown-item" :href="$ceres.urls.registration + '?b2b'">
                    <span class="hidden-xs-down">{{ $translate("ODKleinMore::Template.loginRegisterB2B") }}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import {mapGetters, mapActions, mapState} from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "isLoggedIn"
        ]),

        ...mapState({
            userData: state => state.user.userData,

        }),

        username(){
            let username = "";

            if (isDefined(this.userData))
            {
                if (this.userData.firstName.length)
                {
                    username = this.userData.firstName + " ";
                }
                if (this.userData.lastName.length)
                {
                    username += this.userData.lastName;
                }

                if (this.userData.accounts.length && this.userData.accounts[0].companyName.length)
                {
                    username += this.userData.accounts[0].companyName;
                }
                if (!username.length)
                {
                    const emailOption = this.userData.options.find(option => option.typeId === 2 && option.subTypeId === 4);

                    if (emailOption)
                    {
                        username = emailOption.value;
                    }
                }
            }

            return username.trim();
        }
    },

  data()
  {
    return {
      isLogin: App.templateType === "login",
      isRegister: App.templateType === "register"
    };
  },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
